import { render, staticRenderFns } from "./DuplicateLanguagesModal.vue?vue&type=template&id=17539521&scoped=true&"
import script from "./DuplicateLanguagesModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateLanguagesModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateLanguagesModal.vue?vue&type=style&index=0&id=17539521&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17539521",
  null
  
)

export default component.exports